import TrendingPositiveCard from './trendingPositiveCard.component';

export default TrendingPositiveCard;